module.exports = __webpack_public_path__ + "img/showadz-logo.2abbaf48.svg";